const Import = require('../_import_' + process.env.NODE_ENV)
export default [
  {
    path: '/h5/regist',
    component: Import('user/regist'),
    name: 'regist',
    meta: { title: '注册' }
  },
  {
    path: '/h5/login',
    component: Import('user/login'),
    name: 'login',
    meta: { title: '登录' }
  },
  {
    path: '/h5/forget',
    component: Import('user/forget'),
    name: 'forget',
    meta: { title: '重置密码' }
  },
  {
    path: '/h5/secret',
    component: Import('user/secret'),
    name: 'secret',
    meta: { title: '公证云隐私协议' }
  }
]



// WEBPACK FOOTER //
// ./src/router/model/user.js